module.exports = __webpack_public_path__ + "resources/img/main04.804f18c79801477bf9708a52e93b078f.png";